var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { RadioCheckedIcon, RadioIcon } from '../icons';
import { Radio as MuiRadio, FormControlLabel, styled, radioClasses, formControlLabelClasses } from '@mui/material';
var FormControlLabelRoot = styled(FormControlLabel)(function () {
    var _a;
    return (_a = {},
        _a["& .".concat(formControlLabelClasses.label)] = {
            fontSize: 14,
        },
        _a);
});
var Radio = styled(MuiRadio)(function () {
    var _a, _b;
    return _a = {
            color: 'rgba(0,0,0,.26)',
            width: 36,
            height: 36
        },
        _a["&.".concat(radioClasses.disabled)] = (_b = {
                color: 'rgba(0,0,0, .12)'
            },
            _b["&.".concat(radioClasses.checked)] = {
                color: 'rgba(0,0,0, .24)',
            },
            _b),
        _a;
});
var FormControlLabelAndRadio = React.forwardRef(function (_a, ref) {
    var size = _a.size, value = _a.value, label = _a.label, disabled = _a.disabled, FormControlLabelProps = _a.FormControlLabelProps, RadioProps = _a.RadioProps, icon = _a.icon, checkedIcon = _a.checkedIcon;
    return (React.createElement(FormControlLabelRoot, __assign({ value: value, label: label, disabled: disabled, control: React.createElement(Radio, __assign({ checkedIcon: checkedIcon, icon: icon, ref: ref, size: size }, RadioProps)) }, FormControlLabelProps)));
});
FormControlLabelAndRadio.defaultProps = {
    size: 'medium',
    label: '',
    checkedIcon: React.createElement(RadioCheckedIcon, null),
    icon: React.createElement(RadioIcon, null),
};
export default FormControlLabelAndRadio;
